import {msg} from "@lingui/macro"
import {useLingui} from "@lingui/react"
import {Box, Button, Card, CardContent, CardHeader, Grid, InputAdornment, TextField, Typography} from "@mui/material"
import {Controller, useForm} from "react-hook-form"
import {useState} from "react";
import httpReq from "../../services/httpReq";
import md5 from 'md5'
import {CustomIconButton} from "../../components/buttons/CustomIconButton";
import HomeMadeSnackbar from "../../components/snackbars/HomeMadeSnackbar";
import useMobile from "../../hooks/useMobile";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {showErrorSnackBar} from "../../store/reducers/errors";

const LoginPage = () => {
    const isMobile = useMobile();
    const navigate = useNavigate();
    const {control, getValues} = useForm({mode: 'onChange'})
    const {_} = useLingui()
    const dispatch = useDispatch();

    const [passwordIsVisible, setPasswordIsVisible] = useState(false)

    const doLogin = () => {
        const values = getValues()
        const dataToSend = {
            username: values.username,
            password: md5(values.password).toUpperCase()
        }
        httpReq('Auth/Authenticate', 'POST', dataToSend, false).then(res => {
            if (res.responseAnyError) {
                dispatch(showErrorSnackBar(res.responseMessage));
                return;
            } else {
                localStorage.setItem('asiaUser', JSON.stringify(res.responseData))
                // localStorage.setItem('asiaUserToken', JSON.stringify(res.responseData.authenticateResponse.access_token))
                localStorage.setItem('asiaUserToken',JSON.stringify({
                    token: res.responseData.authenticateResponse.access_token,
                    expiresIn: res.responseData.authenticateResponse.expires_in,
                }))
                navigate('/Home')
            }
        })
    }

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <Box sx={{height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Card sx={{
                    p: 3,
                    borderRadius: 4,
                    boxShadow: 10,
                    backgroundColor: 'white',
                    animation: 'fadeInUp 0.6s ease-out', height: '55vh', width: '25vw'
                }}>
                    <CardHeader sx={{textAlign: 'center', marginTop: 2}}
                                title={<img style={{height: 80, marginBottom: 8}} src={"/assets/asia_logo_black.png"}
                                            alt={'Asia logo'}/>}
                                subheader={'Sign in'}/>
                    <CardContent>
                        <Grid container sx={{display: 'flex', gap: 2}}>
                            <Grid item xs={12}
                                  sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2}}>
                                <Controller
                                    name='username'
                                    control={control}
                                    defaultValue=""
                                    fullWidth
                                    render={({field, fieldState}) => (
                                        <TextField
                                            sx={{display: 'flex', flex: 2}}
                                            margin={isMobile ? 'dense' : 'normal'}
                                            fullWidth
                                            required
                                            label={_(msg`Username`)}
                                            autoComplete='username'
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? fieldState.error.message : null}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}
                                  sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2}}>
                                <Controller
                                    name='password'
                                    fullWidth
                                    control={control}
                                    defaultValue=""
                                    render={({field, fieldState}) => (
                                        <TextField
                                            sx={{display: 'flex', flex: 2}}
                                            margin={isMobile ? 'dense' : 'normal'}
                                            fullWidth
                                            required
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <CustomIconButton
                                                            color={'primary'}
                                                            variant={'filled'}
                                                            onClick={() => setPasswordIsVisible(!passwordIsVisible)}
                                                            size={'small'}
                                                            disabled={false}
                                                            icon={passwordIsVisible ? 'view' : 'hide'}
                                                            iconSize={'small'}
                                                            onMouseDown={handleMouseDownPassword}
                                                        />
                                                    </InputAdornment>
                                                )
                                            }}
                                            type={passwordIsVisible ? 'text' : 'password'}
                                            label={_(msg`Password`)}
                                            autoComplete='password'
                                            error={!!fieldState.error}
                                            helperText={fieldState.error ? fieldState.error.message : null}
                                            {...field}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid sx={{display: 'flex', justifyContent: 'center'}} item xs={12}>
                                <Button onClick={() => {
                                    doLogin()
                                }} sx={{width: '40%'}} variant="contained">Login</Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box
                    component="a"
                    href={"https://www.fredeng.eu/"}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        cursor: 'pointer',
                        position: 'absolute',
                        bottom: 16,
                        right: 16,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        px: 2,
                        py: 1,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        borderRadius: 2,
                        boxShadow: 1,
                    }}
                >
                    <Typography sx={{textDecoration: 'underline'}} variant="body2" color="text.secondary">
                        Powered by
                    </Typography>
                    <Box
                        component="img"
                        src="/assets/fred-logo-login.png"
                        alt="Fred logo"
                        sx={{height: 64}}
                    />
                </Box>
                <HomeMadeSnackbar/>
            </Box>
        </>
    )
}
export default LoginPage